import { lazy } from 'react';
import store from 'store';
import { setChunkReloadFailed } from 'store/Shared.Slice';

const CHUNK_RELOAD_FLAG = 'chunkReloadAttempted';

/**
 * A React.lazy wrapper that dynamically loads a React component.
 *
 * @param {Function} importFunction - A function that dynamically imports a component.
 * @returns A lazily loaded React component.
 *
 * A failed import usually means the app was redeployed while this tab was open,
 * so the chunk hash it's asking for no longer exists. We reload once to pick up
 * the current build; if that doesn't fix it, it's a real error, so we surface a
 * fixed notice with a manual refresh link instead of reloading forever.
 */
export default function lazyPage(importFunction) {
  return lazy(async () => {
      try {
        const module = await importFunction();
        sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
        return module;
      }
      catch (error) {
        console.error(`Failed to load component: ${error}`);
        if (!sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
          sessionStorage.setItem(CHUNK_RELOAD_FLAG, 'true');
          window.location.reload();
          return new Promise(() => {});
        }
        sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
        store.dispatch(setChunkReloadFailed(true));
      }
  });
}
